import React, { useState } from 'react'
import { setModal, selectModal } from "../../redux/modalSlice"
import { useDispatch, useSelector } from 'react-redux'

export default function AlertModal() {
  const dispatch = useDispatch()
  const modal = useSelector(selectModal)
  const formatTitle = (title) => {
    if (!title) return '';
    let result = title.replace(/_/g, ' ');
    result = result.charAt(0).toUpperCase() + result.slice(1);
    return result;
  }

  const handleNo = async () => {
    if (typeof modal.options?.closeMethod === 'function') {
      await modal.options.closeMethod();
    }
    dispatch(setModal({ is_active: false }));
  };

  return modal.is_active && modal.type === 'alert_modal' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card column is-10-tablet is-5-fullhd is-12-mobile">
        <header className={`modal-card-head has-bg-${modal.options?.type} py-3`}>
          <p className="modal-card-title is-capitalized">
            {formatTitle(modal.options?.title)}
          </p>
          <button className="delete" aria-label="close" onClick={handleNo}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ minHeight: "100px", maxHeight: "600px", overflow: 'hidden' }}
        >
          {modal.options?.description}
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1 pr-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleNo}>
              {modal.options?.button_name ? modal.options.button_name : 'Done'}
            </button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
